import { playerReducer } from "./player/reducer";
import { quizReducer } from "./quiz/reducer";
import { quizWrapperReducer } from "./quizWrapper/reducer";
import { roomReducer } from "./room/reducer";


export default { playerReducer, quizReducer, quizWrapperReducer, roomReducer };